import { useQuery } from '@tanstack/react-query';
import { getCitySuggestions, getStreetSuggestions } from '@/api/geoAutocomplete/geoAutocomplete';

export const useCitySuggestions = (postalCode: string) => {
  return useQuery({
    queryKey: ['geo-autocomplete', 'cities', postalCode],
    queryFn: ({ signal }) => getCitySuggestions(postalCode, signal),
    enabled: /^\d{5}$/.test(postalCode),
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
    useErrorBoundary: false,
  });
};

export const useStreetSuggestions = (postalCode: string, city: string, street: string) => {
  const cityQuery = city.trim();
  const streetQuery = street.trim();
  return useQuery({
    queryKey: ['geo-autocomplete', 'streets', postalCode, cityQuery, streetQuery],
    queryFn: ({ signal }) => getStreetSuggestions(postalCode, cityQuery, streetQuery, signal),
    enabled: /^\d{5}$/.test(postalCode) && !!cityQuery,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
    useErrorBoundary: false,
  });
};
